import Vue from "vue"
import VueI18n from "vue-i18n"
import dayjs from "dayjs"
import "dayjs/locale/ru"
import vuetify from "@/plugins/vuetify"
import en from "@/locales/en.json"
import ru from "@/locales/ru.json"
import {
  availableLocales,
  getInitialLocale,
  LOCALE_STORAGE_KEY,
} from "./locale"

Vue.use(VueI18n)

/** Russian plural forms: 0 — one (1, 21), 1 — few (2-4, 22-24), 2 — many (0, 5-20, 25...) */
const ruPlural = (choice, choicesLength) => {
  if (choicesLength < 3) return choice === 1 ? 0 : 1
  const n = Math.abs(choice) % 100
  const n1 = n % 10
  if (n > 10 && n < 20) return 2
  if (n1 === 1) return 0
  if (n1 >= 2 && n1 <= 4) return 1
  return 2
}

const initialLocale = getInitialLocale()

export const i18n = new VueI18n({
  locale: initialLocale,
  fallbackLocale: "en",
  messages: { en, ru },
  pluralizationRules: { ru: ruPlural },
  silentFallbackWarn: true,
})

const applyLocale = (code) => {
  i18n.locale = code
  vuetify.framework.lang.current = code
  dayjs.locale(code)
  document.documentElement.lang = code
}

/** Switches the UI language and remembers the choice */
export const setLocale = (code) => {
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, code)
  } catch (e) {}
  applyLocale(code)
}

/** Shorthand for translating outside of components */
export const t = (...args) => i18n.t(...args)
export const tc = (...args) => i18n.tc(...args)

export { availableLocales }

applyLocale(initialLocale)

export default i18n
